import {
  Box,
  BoxProps,
  Button,
  Divider,
  Heading,
  List,
  Text,
} from "@chakra-ui/react";
import { FlushedDetail } from "./flushed-detail";

export interface FlushedCardProps extends BoxProps {
  featuresHeader?: string;
  features: {
    label: string;
    icon?: any;
  }[];
  name: string;
  subtitle: string;
  caption: string;
  description: string;
  value: string;

  colorScheme: string;
  action: {
    label: string;
    onClick?: () => void;
  };
}

export const FlushedCard = (props: FlushedCardProps) => {
  const {
    featuresHeader,
    features,
    name,
    description,
    subtitle,
    value,
    caption,
    action,
    colorScheme: c,
    ...rest
  } = props;

  return (
    <Box p={{ base: "10", md: "16" }} {...rest}>
      <Heading>{name}</Heading>
      <Divider
        opacity={1}
        borderWidth="2px"
        borderColor={`${c}.500`}
        my="6"
        w="100%"
      />

      <Text maxW="280px" fontSize="lg">
        {description}
      </Text>

      <Box mt="2">
        <Text fontSize={{ base: "6xl", md: "7xl" }} fontWeight="extrabold">
          {value}
        </Text>
        <Text casing="uppercase" fontWeight="bold">
          {subtitle}
        </Text>
        <Text mt="2" color={"blueGray.600"}>
          {caption}
        </Text>
      </Box>

      <Button
        my="8"
        size="lg"
        fontSize="md"
        colorScheme={c}
        onClick={action.onClick}
      >
        {action.label}
      </Button>

      <Box>
        <Text fontWeight="bold" mb="6">
          {featuresHeader}
        </Text>
        <List spacing="7">
          {features.map((feature, index) => (
            <FlushedDetail key={index} {...feature} />
          ))}
        </List>
      </Box>
    </Box>
  );
};
